import { CalendarPlus } from "lucide-react";

import Button from "../shared/Button";

export default function FollowupToolbar({

    total = 0,

    onCreate

}){

    return(

        <div className="crm-followup-toolbar">

            <div>

                <h3>

                    Follow-ups

                </h3>

                <p>

                    {total} Scheduled

                </p>

            </div>

            <Button

                icon={<CalendarPlus size={18}/>}

                onClick={onCreate}

            >

                Schedule

            </Button>

        </div>

    );

}